<i18n src="../../locales/lang.json"></i18n>
<template>
  <div v-show="scheduleid>0" class="container-fluid" id="procedure-done-reject-container" style="background-color: white; border: 1px solid red;">
    <div class="row py-2">
      <div class="col-4 text-right">
        <button type="button" class="btn btn-success mr-3" @click="setDone" style="min-width:100px !important;">{{$t('done')}}</button>
      </div>
      <div class="col-8 text-left">
        <!--<button type="button" class="btn btn-warning ml-3" @click="setNotDone" style="min-width:100px !important;">{{$t('not_done')}}</button>-->
        <div class="btn-group">
          <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{$t('not_done')}}</button>
          <div class="dropdown-menu dropdown-menu-right" style="">
            <a href="#" class="dropdown-item" @click="setNotDoneMessage(20)">{{$t('status_notime')}}</a>
            <a href="#" class="dropdown-item" @click="setNotDoneMessage(21)">{{$t('status_notable')}}</a>
            <a href="#" class="dropdown-item" @click="setNotDoneMessage(22)">{{$t('status_missing_information')}}</a>
            <a href="#" class="dropdown-item" @click="setNotDoneMessage(23)">{{$t('status_notneeded')}}</a>
          </div>
        </div>
      </div>
    </div>
    <modal-default v-bind:title="$t('leave_note')" ref="thisModal" v-bind:onsave="setMessage" size="modal-xs mx-4 mx-md-auto">
      <div class="row">
        <div class="col-12">
          {{$t('status_change_message')}}
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <textarea v-model="message" class="form-control"></textarea>
        </div>
      </div>
    </modal-default>
  </div>
</template>

<script>

  export default {
    name: "procedure-done-reject",
    components: {
      
    },
    props: {
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        message:''
      };
    },
    
    methods: {
      setMessage() {
        var message = "" + this.message;
        this.$emit('add_chat_message', message);
        this.message = "";
        this.$forceUpdate();
        this.$refs.thisModal.close();
      },
      setDone() {
        this.setStatus(2);
      },
      setNotDone(status) {
        this.setStatus(status, false);
      },
      setNotDoneMessage(status) {
        this.setStatus(status, true);
        this.$refs.thisModal.open();
      },
      getId() {
        return this._uid;
      },
      handleRefresh(val) {

      },
      setStatus(status, promtmessage) {

        var procedureid = this.procedure.ProcedureId;
        try {
          var url = "/api/Procedure/SetStatus?procedureid=" + procedureid + "&procedureScheduleid=" + this.scheduleid + "&status=" + status;
          this.$http.get(url).then(response => {
            vm.$root.$emit('doSearch');

            if (promtmessage == true) {
              vm.$root.$emit('procedure_open_chat');
            }
            else {
              vm.$root.$emit('procedure_editor_can_close');
            }
            
          });
        }
        catch (err) {

        }
      }
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 9");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    mounted() {
     
    },

    created: function () {

    },

    watch: {
     
    },
    created() {
      
    },
  };

</script>

<style scoped>
  #procedure-done-reject-container {
    border: 1px solid white;
  }


</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-done-reject.vue